import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GlobalValidationService } from '../global-validation.service';

@Component({
  selector: 'app-agent-mobile-confirmation',
  templateUrl: './agent-mobile-confirmation.component.html',
  styleUrls: ['./agent-mobile-confirmation.component.scss']
})
export class AgentMobileConfirmationComponent implements OnInit {
  mobile: any;
  user_id: any;
  entered_mobile_number: any;

  constructor(public dialogRef: MatDialogRef<AgentMobileConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService, private global: GlobalService, private formBuilder: FormBuilder) {
    console.log(data);
    this.mobile = data['mobile'];
    this.user_id = data['user_id'];
  }

  confirmButtonClicked() {
    let data_dict = {
      'user_type_id': 2,
      'user_id': this.user_id,
      'mobile_number': this.mobile
    };
    this.httpService.confirmMobileVerfication(data_dict).subscribe((data) => {
      this.dialogRef.close(false);
    }, (error) => {
      console.error(error);
    });
  }

  confirmWithNewNumberButtonClicked() {
    let data_dict = {
      'user_type_id': 2,
      'user_id': this.user_id,
      'mobile_number': this.entered_mobile_number
    };
    this.httpService.confirmMobileVerfication(data_dict).subscribe((data) => {
      this.dialogRef.close(false);
    }, (error) => {
      console.error(error);
    });
  }


  closeComponent() {
    this.dialogRef.close(false);
  }

  ngOnInit() {
  }

}
